import { getRepository } from './repository';

const resource = "/project";

export default {
    listProjects(templateFormatId, headers) {
        return getRepository().get(`${resource}/list`, { params: { "templateFormatId": templateFormatId }, headers : headers })
    },
    getProject(projectId, headers) {
        return getRepository().get(`${resource}/details/${projectId}`, { headers : headers })
    },
    async getProjectPage(projectId, pageNumber, headers) {
        const response = await getRepository().get(`${resource}/details/${projectId}/page/${pageNumber}`, { headers : headers }) 

        return response;
    },
    createProject(payload, headers) {
        return getRepository().post(`${resource}/add`, payload, {headers : headers});
    },
    saveProject(payload, headers) {
        return getRepository().post(`${resource}/update`, payload, {headers : headers});
    },
    removeProject(projectId, headers) {
        return getRepository().post(`${resource}/remove`, {"id" : projectId}, {headers : headers});
    }
};